// custom subscription element
class Subscription extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
  }

  connectedCallback() {
    console.log("Subscription element added to page");
    this.select.addEventListener('change', this.onSelectChange);
  } 
    onSelectChange(event) {
    // get the selected option
    const selectedOption = event.target.value;
    console.log(selectedOption);
    let selling_plan_input = document.querySelector('input[name="selling_plan"]')

    // set the selling plan value
    if (selectedOption && selling_plan_input) {
        selling_plan_input.value = selectedOption;
    }
}

}

if (!customElements.get("subscription-select")) {
  customElements.define("subscription-select", Subscription);
}
